import styled from 'styled-components';

export const SectionTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.colors.textPrimarySecondary1100};
`;

export const StepperWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
